import { createFileRoute } from '@tanstack/react-router';
import BookmarkListPage from '../components/BookmarkListPage';
import { useUserPreferences } from '../hooks/useUserPreferences';
import { useFolderBookmarks } from '../services/dataHooks';
import { useFolderBySlug } from '../hooks/useFolderBySlug';
import { validateListPageSearch } from '../utils/listPageSearch';

export const Route = createFileRoute('/_app/folder/$slug/')({
  validateSearch: validateListPageSearch,
  component: FolderIndexPage,
});

function FolderIndexPage() {
  const { slug } = Route.useParams();
  const search = Route.useSearch();
  const page = search.page ?? 1;
  const navigate = Route.useNavigate();
  const { preferences } = useUserPreferences();
  const currentFolder = useFolderBySlug(slug);
  const {
    bookmarks,
    hasMore,
    isLoading: isBookmarkCollectionLoading,
  } = useFolderBookmarks(currentFolder?.id || '', page);

  const updatePageSearch = (nextPage: number) => {
    const safePage = Math.max(1, nextPage);
    navigate({
      replace: true,
      search: (prev) => {
        if (safePage <= 1) {
          if (prev.page === undefined) return prev;
          const { page: _page, ...rest } = prev;
          return rest;
        }
        if (prev.page === safePage) return prev;
        return { ...prev, page: safePage };
      },
    });
  };

  return (
    <BookmarkListPage
      mode="folder"
      bookmarks={bookmarks}
      currentPage={page}
      currentFolderId={currentFolder?.id}
      currentFolder={currentFolder}
      folderTitle={currentFolder?.displayTitle}
      condensedView={preferences.bookmarkList.view === 'condensed'}
      showThumbnails={preferences.bookmarkList.thumbnails}
      isLoading={isBookmarkCollectionLoading}
      hasMore={hasMore}
      onPageChange={updatePageSearch}
    />
  );
}
